import React from 'react'
import {
  SortableContext,
  useSortable,
  rectSortingStrategy,
} from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

interface WidgetItem {
  id: string
  node: React.ReactNode
}

interface DraggableWidgetGridProps {
  items: WidgetItem[]
  editMode: boolean
}

function SortableWidget({ item, editMode }: { item: WidgetItem; editMode: boolean }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: item.id,
    disabled: !editMode,
  })

  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
        position: 'relative',
      }}
    >
      {editMode && (
        <div
          ref={setActivatorNodeRef}
          {...attributes}
          {...listeners}
          role="button"
          aria-label="Flyt widget"
          style={{
            position: 'absolute',
            top: 10,
            right: 12,
            zIndex: 10,
            color: '#4f46e5',
            fontSize: 18,
            cursor: 'grab',
            userSelect: 'none',
            padding: '2px 4px',
            lineHeight: 1,
          }}
        >
          ⠿
        </div>
      )}
      {item.node}
    </div>
  )
}

export function DraggableWidgetGrid({ items, editMode }: DraggableWidgetGridProps) {
  return (
    <SortableContext items={items.map((i) => i.id)} strategy={rectSortingStrategy}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
        {items.map((item) => (
          <SortableWidget key={item.id} item={item} editMode={editMode} />
        ))}
      </div>
    </SortableContext>
  )
}
